import BaseService from "@/services/BaseService";

export default class ShareModelPlanService extends BaseService {
  constructor() {
    super('insurance_pricing/share_models');
  }

  findAllByShareModelId(shareModelId, data) {
    return this.http.get(`${this._serviceName}/${shareModelId}/plans`, { params: data });
  }

  save(shareModelId, data) {
    return this.http.post(`${this._serviceName}/${shareModelId}/plans`, data);
  }

  delete(shareModelId, id) {
    return this.http.delete(`${this._serviceName}/${shareModelId}/plans/${id}`)
  }

  update(shareModelId, id, data) {
    return this.http.put(`${this._serviceName}/${shareModelId}/plans/${id}`, data)
  }

  updateCopay(shareModelId, id, data) {
    return this.http.put(`${this._serviceName}/${shareModelId}/plans/${id}/copay`, data)
  }
}
